import type { TabCardItemPropsServer } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";
import { RichTextRenderer } from "../../../renderer/RichTextRenderer";

const TabCardItem = ({ children, ...rest }: TabCardItemPropsServer) => {
  return (
    <LazyComponent name="TabCardItem" {...rest}>
      <RichTextRenderer content={children} />
    </LazyComponent>
  );
};

export default TabCardItem;
